import * as React from 'react';
import { assertNever, IncidentType } from '../../amorg-common';
import { Icon, iconName } from '../icons/Icons';
import { ProtectedPageContext } from '../../pages/_contexts/ProtectedPageContext';


type IncideptIconProps = {
    type:IncidentType
}
export const IncidentIcon = ({ type }: IncideptIconProps): JSX.Element => {

    const ctx = React.useContext(ProtectedPageContext);

    let icon:iconName = 'status_error';
    let color:string = ctx.colors.icon.default;
    switch (type)
    {
        case 'issue': 
            icon = 'report'; 
            color = ctx.colors.icon.info;
            break;
        case 'almost-accident': 
            icon = 'falling'; 
            color = ctx.colors.icon.warning;
            break;
        case 'work-injury': 
            icon = 'personal_injury'; 
            color = ctx.colors.icon.error;
            break;
        case 'whistleblower': 
            icon = 'domino_mask'; 
            color = ctx.colors.icon.default;
            break;
        default: assertNever(type);
    }


    return (
        <Icon name={icon} size='medium' color={color} />
    );
} 